import { ConfiguracaoResultadoSorteioModel } from "../models/configuracaoResultadoSorteio/configuracaoResultadoSorteioModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toastError, toastSucess } from "../util/toast";
import { setPageConfiguracaoResultadoSorteio } from "../redux/slices/configuracaoResultadoSorteio/configuracaoResultadoSorteioSlice";

export const cadastrarConfiguracaoResultadoSorteio = createAsyncThunk("/ConfiguracaoResultadoSorteio/CadastrarConfiguracaoResultadoSorteio", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/ConfiguracaoResultadoSorteio/CadastrarConfiguracaoResultadoSorteio", payload.value);
    toastSucess("Configuração de ponto de equilíbrio cadastrada com sucesso");
    dispatch(setPageConfiguracaoResultadoSorteio("geral"));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarConfiguracaoResultadoSorteio = createAsyncThunk("/ConfiguracaoResultadoSorteio/BuscarConfiguracaoResultadoSorteio", async () => {
  try {
    const data = await api.get("/ConfiguracaoResultadoSorteio/BuscarConfiguracaoResultadoSorteio");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarUltimaDataSorteioConfiguracao = createAsyncThunk("/ConfiguracaoResultadoSorteio/BuscarUltimaDataSorteioConfiguracao", async (idEmpresa: number | null) => {
  try {
    const data = await api.get("/ConfiguracaoResultadoSorteio/BuscarUltimaDataSorteioConfiguracao", { params: { idEmpresa: idEmpresa } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const listarConfiguracaoResultadoSorteio = createAsyncThunk("/ConfiguracaoResultadoSorteio/ListarConfiguracaoResultadoSorteio", async (idEmpresa: number) => {
  try {
    const data = await api.get("/ConfiguracaoResultadoSorteio/ListarConfiguracaoResultadoSorteio", { params: { idEmpresa: idEmpresa } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarConfiguracaoResultadoSorteio = createAsyncThunk("/ConfiguracaoResultadoSorteio/AtualizarConfiguracaoResultadoSorteio", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/ConfiguracaoResultadoSorteio/AtualizarConfiguracaoResultadoSorteio", payload.value);
    toastSucess("Configuração de ponto de equilíbrio atualizada com sucesso");
    dispatch(setPageConfiguracaoResultadoSorteio("geral"));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
